import { useQuery } from '@tanstack/react-query';
import { api } from './api';

type AppConfig = {
  stripe_publishable_key: string;
};

export function useAppConfig() {
  return useQuery({
    queryKey: ['app-config'],
    queryFn: async (): Promise<AppConfig> => {
      const { data } = await api.get<AppConfig>('/v1/config');
      return data;
    },
    staleTime: 60 * 60_000,
  });
}
